import { CiaIntegration } from '~/types/integrations/cia/CiaIntegration';

export default (instance: CiaIntegration) => {
  return (userId: string) => {
    instance.state.userId.value = userId;
  };
};
